import { useEffect } from "react";

const SITE = "https://beautifycornwall.com";

export default function usePageMeta(title, description, { noindex = false } = {}) {
  useEffect(() => {
    document.title = title;
    if (description) {
      const m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", description);
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      const path = window.location.pathname.replace(/\/$/, "");
      canonical.setAttribute("href", `${SITE}${path || "/"}`);
    }
    let robots = document.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!robots) {
        robots = document.createElement("meta");
        robots.setAttribute("name", "robots");
        document.head.appendChild(robots);
      }
      robots.setAttribute("content", "noindex, follow");
    } else if (robots) {
      robots.remove();
    }
  }, [title, description, noindex]);
}
